import React from 'react';
import classes from './SendFeedback.module.css';
import SendFeedbackIcon from 'assets/images/liefIcons/send-feedback.svg';

const sendFeedback = () => {
  const handleShowUserSnapFeedbackTool = () => {
    window.Usersnap.show(process.env.REACT_APP_USERSNAP_FEEDBACK_API_KEY).then((widgetApi) => widgetApi.open());
  };
  return (
    <div className={classes.SendFeedback} onClick={() => handleShowUserSnapFeedbackTool('feedback')}>
      <img src={SendFeedbackIcon} alt="send-feedback" className={classes.SendFeedbackIcon} />
      <h3>Send Ideas</h3>
    </div>
  );
};

export default sendFeedback;
